
import React, { useEffect, useState } from "react";
import {
  Mail,
  Phone,
  MapPin,
  ArrowRight,
  Facebook,
  Youtube,
} from "lucide-react";
import { AshtadalKamal } from "./AipanPattern";

export default function Footer() {
  const latitude = 29.391374;
  const longitude = 79.445915;
const [weather, setWeather] = useState(null);
const [airQuality, setAirQuality] = useState(null);
const [weatherError, setWeatherError] = useState(false);
const [currentTime, setCurrentTime] = useState(new Date());


useEffect(() => {
  const timer = setInterval(() => {
    setCurrentTime(new Date());
  }, 1000);

  return () => clearInterval(timer);
}, []);
useEffect(() => {
 
const fetchWeather = async () => {
  

  const weatherUrl =
    `https://api.open-meteo.com/v1/forecast?latitude=${latitude}&longitude=${longitude}&current=temperature_2m,relative_humidity_2m,apparent_temperature,is_day,precipitation,weather_code,wind_speed_10m&timezone=Asia%2FKolkata`;

  const airUrl =
    `https://air-quality-api.open-meteo.com/v1/air-quality?latitude=${latitude}&longitude=${longitude}&current=pm2_5,us_aqi&timezone=Asia%2FKolkata`;

  try {
    const response = await fetch(weatherUrl);

    if (!response.ok) {
      throw new Error("Weather API request failed");
    }

    const data = await response.json();

    if (!data.current) {
      throw new Error("Weather data missing");
    }

    setWeather(data.current);
    setWeatherError(false);
  } catch (error) {
    console.error("Weather API error:", error);
    setWeatherError(true);
  }

  try {
    const response = await fetch(airUrl);

    if (!response.ok) {
      throw new Error("Air quality API request failed");
    }

    const data = await response.json();
    setAirQuality(data.current ?? null);
  } catch (error) {
    console.error("Air quality API error:", error);
    setAirQuality(null);
  }
};

  fetchWeather();

  const interval = setInterval(fetchWeather, 15 * 60 * 1000);

  return () => clearInterval(interval);
}, []);

const getWeatherDescription = (code) => {
  if (code === 0) return "Clear Sky";
  if ([1, 2, 3].includes(code)) return "Partly Cloudy";
  if ([45, 48].includes(code)) return "Foggy";
  if ([51, 53, 55, 56, 57].includes(code)) return "Drizzle";
  if ([61, 63, 65, 66, 67, 80, 81, 82].includes(code)) return "Rain";
  if ([71, 73, 75, 77, 85, 86].includes(code)) return "Snow";
  if ([95, 96, 99].includes(code)) return "Thunderstorm";
  return "Weather Update";
};

const getWeatherIcon = (code, isDay) => {
  if (code === 0) return isDay ? "☀️" : "🌙";
  if ([1, 2].includes(code)) return isDay ? "🌤️" : "☁️";
  if ([3, 45, 48].includes(code)) return "☁️";
  if ([51, 53, 55, 56, 57].includes(code)) return "🌦️";
  if ([61, 63, 65, 66, 67, 80, 81, 82].includes(code)) return "🌧️";
  if ([71, 73, 75, 77, 85, 86].includes(code)) return "🌨️";
  if ([95, 96, 99].includes(code)) return "⛈️";
  return "🌡️";
};

  const footerColumns = [
    {
      t: "Quick Links",
      items: [
        { name: "NIRF", url: "/nirf", external: false },
        {
          name: "IQAC",
          url: "/cell-club/Internal-Quality-Assurance-Cell-(IQAC)",
          external: false,
        },
        {
          name: "KU ERP Login-Student",
          url: "https://kuntl.net/students/login",
          external: true,
        },
        {
          name: "KU ERP Login-College",
          url: "https://kuntl.net/college/College",
          external: true,
        },
        {
          name: "KU Samarth Login - Student",
          url: "https://kunainital.samarth.edu.in/",
          external: true,
        },
        {
          name: "KU Samarth Login - College",
          url: "https://kunainital.samarth.ac.in/index.php/site/login",
          external: true,
        },
      ],
    },
    {
      t: "Important Links",
      items: [
        {
          name: "DEGREE",
          url: "https://kuntl.net/ku-original-degree/",
          external: true,
        },
        {
          name: "RTI",
          url: "https://kuntl.net/rti-online-live/",
          external: true,
        },
        {
          name: "RDET Vacancy 2024",
          url: "https://kuntl.net/rdet_vacancy/",
          external: true,
        },
      ],
    },
    {
      t: "Downloads",
      items: [
        {
          name: "Academic Calendars",
          url: "/academic-calendars",
          external: false,
        },
        {
          name: "News Letter 'Bakhlee'",
          url: "/bakhlee",
          external: false,
        },
        {
          name: "Green Campus Certificate",
          url: "/green-campus-certificate",
          external: false,
        },
      ],
    },
  ];

  return (
    <footer className="relative overflow-hidden bg-gradient-to-r from-[var(--terracotta-deep)] via-[var(--terracotta)] to-[var(--saffron)] text-white font-gill">

      {/* Decorative Background */}
      <div className="absolute -right-16 -top-16 opacity-10 pointer-events-none">
        <AshtadalKamal size={280} stroke="#f4b063" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 pt-10 pb-4">

        {/* Footer Main Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">

          {/* University Information */}
          <div className="lg:col-span-2">

            <div className="flex items-center justify-start">
              <div className="w-full max-w-[420px]">
                <img
                  src="/images/kumaun_logo_white_new-5.png"
                  alt="Kumaun University Logo"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>

            <p className="mt-5 text-sm leading-relaxed text-white/75 max-w-md">
              A leading state university of Uttarakhand serving thousands
              of students through two constituent campuses and a wide
              network of affiliated colleges.
            </p>

            <div className="mt-6 space-y-3 text-[13.5px] text-white/80">

              <div className="flex items-start gap-3">
                <MapPin
                  size={16}
                  className="mt-1 shrink-0 text-[var(--saffron-light)]"
                />
                <span>
                  Sleepy Hollow, Nainital-263001,
                  Uttarakhand, India.
                </span>
              </div>

              <div className="flex items-center gap-3">
                <Phone
                  size={16}
                  className="shrink-0 text-[var(--saffron-light)]"
                />
                <span>05942-235563</span>
              </div>

              <div className="flex items-center gap-3">
                <Mail
                  size={16}
                  className="shrink-0 text-[var(--saffron-light)]"
                />
                <a href="mailto:registrar@kunainital.ac.in">
                  registrar@kunainital.ac.in
                </a>
              </div>

            </div>

            {/* Social Media */}
            <div className="mt-6 flex gap-3">
              {[
                {
                  icon: Facebook,
                  link: "YOUR_FACEBOOK_LINK",
                  label: "Facebook",
                },
                {
                  icon: Youtube,
                  link: "https://youtube.com/watch?v=RCJ-qyWRUbI&feature=shared",
                  label: "YouTube",
                },
              ].map(({ icon: Icon, link, label }) => (
                <a
                  key={label}
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  className="h-9 w-9 grid place-items-center rounded-full bg-white/10 border border-white/15 hover:bg-[var(--terracotta)] hover:border-white/40 transition-colors"
                >
                  <Icon size={16} />
                </a>
              ))}
           

            </div>
          

          </div>

          {/* Footer Link Columns */}
          {footerColumns.map((col) => (
            <div key={col.t}>

              <h4 className="font-display font-bold text-[15px] text-white uppercase tracking-wider">
                {col.t}
              </h4>

              <div className="mt-4 h-0.5 w-8 bg-[var(--saffron)] rounded-full" />

              <ul className="mt-5 space-y-3">
                {col.items.map((item) => (
                  <li key={item.name}>
                    <a
                      href={item.url}
                      target={item.external ? "_blank" : undefined}
                      rel={
                        item.external
                          ? "noopener noreferrer"
                          : undefined
                      }
                      className="text-[13.5px] text-white/75 hover:text-[var(--saffron-light)] transition-colors"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>

            </div>
          ))}

        </div>

        {/* Map and Address - Separate Row */}
       <div className="mt-12 grid grid-cols-1 lg:grid-cols-12 gap-0 overflow-hidden rounded-xl shadow-lg">

  {/* Left Side - Google Map (Same as Before) */}
  <div className="lg:col-span-7 min-h-[320px] lg:min-h-[340px]">
    <iframe
      title="Kumaun University Location"
      src="https://maps.google.com/maps?q=Kumaun%20University%2C%20Sleepy%20Hollow%2C%20Nainital&t=&z=15&ie=UTF8&iwloc=&output=embed"
      className="block w-full h-[340px] lg:h-[360px]"
      style={{ border: 0 }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    />
  </div>

  {/* Right Side - Weather */}
 {/* Right Side - Weather */}
<div className="lg:col-span-5 relative overflow-hidden bg-[#222432] p-1 text-white flex flex-col justify-center">
  {/* Location */}
  <div className="flex items-center gap-2 text-lg">
    <span>☁️</span>
    <span>Kumaun University, Nainital</span>
  </div>

  <div className="mt-3 h-[2px] w-16 bg-red-500"></div>

  
{/* Live Date and Time */}
<p className="mt-4 text-sm text-gray-400">
  {currentTime.toLocaleString("en-IN", {
    weekday: "long",
    day: "2-digit",
    month: "long",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
    timeZone: "Asia/Kolkata",
  })}
</p>

  {weatherError ? (
    <p className="mt-4 text-sm text-red-300">
      Weather data is currently unavailable.
    </p>
  ) : !weather ? (
    <p className="mt-4 text-sm text-gray-300">
      Loading live weather...
    </p>
  ) : (
    <>
      {/* Weather and Temperature */}
      <div className="mt-4 flex items-center gap-4">
        <span className="text-3xl">
          {getWeatherIcon(weather.weather_code, weather.is_day)}
        </span>

        <div>
          <p className="text-lg font-bold">
            {getWeatherDescription(weather.weather_code)}
          </p>

          <p className="mt-1 text-base text-gray-300">
            Temp: {Number(weather.temperature_2m).toFixed(2)}°C
          </p>
        </div>
      </div>

      {/* Humidity and Wind */}
      <p className="mt-4 text-sm text-gray-400">
        Humidity: {weather.relative_humidity_2m}% &nbsp;
        Wind: {weather.wind_speed_10m} km/h
      </p>

      {/* Air Pollution */}
      <div className="mt-2 min-h-[76px] border-2 border-dotted border-gray-500 p-3">
        <div className="flex flex-wrap items-center gap-2">
          <span className="text-base">
            Air Pollution (PM2.5):
          </span>

          {airQuality?.pm2_5 != null ? (
            <>
              <span className="font-semibold">
                {Number(airQuality.pm2_5).toFixed(1)} µg/m³
              </span>
              {/* <span className="text-2xl text-green-500">♥</span> */}
            </>
          ) : (
            <span className="text-sm text-gray-400">
              Unavailable
            </span>
          )}
        </div>
      </div>

      {/* Source */}
      <p className="mt-1 text-right text-xs text-gray-400">
        {/* Source */}
        Latitude: {latitude}, Longitude: {longitude}
      </p>
    </>
  )}

  {/* Directions */}
  <a
    href="https://www.google.com/maps/search/?api=1&query=Kumaun+University+Sleepy+Hollow+Nainital"
    target="_blank"
    rel="noopener noreferrer"
    className="mt-4 inline-flex w-fit items-center gap-2 rounded-lg bg-[#ff9d2e] px-4 py-2 text-sm font-bold text-white transition-colors hover:bg-[#ed8a1c]"
  >
    Get Directions <ArrowRight size={16} />
  </a>
</div>
</div>
        {/* Copyright */}
        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-[12.5px] text-white/60">

          <div>
            © {new Date().getFullYear()} Kumaun University, Nainital.
            All rights reserved.
          </div>

          <div className="font-serif italic">
            Crafted with care in the hills of Kumaon.
          </div>

        </div>

      </div>
    </footer>
  );
}
